import Button from 'components/button';
import { css } from '@emotion/react';
import { Flex } from 'components/box';
import { Text } from 'components/typography';
import { Icon as IconType, Info } from 'react-feather';

const InfoLabel = ({
  icon: Icon,
  onClick,
  text,
  iconWidth = '18px',
}: {
  icon: IconType;
  onClick?: () => void;
  text: string;
  iconWidth?: string;
}) => (
  <Flex
    alignItems="center"
    justifyContent="flex-start"
    css={theme => css`
      gap: ${theme.space[3]}px;
    `}
  >
    <Icon
      size={iconWidth}
      css={theme => css`
        stroke: ${theme.colors.primary};
      `}
    />

    {onClick ? (
      <Button
        variant="flat"
        onClick={onClick}
        p={0}
        fontWeight={600}
        fontColor="darkGrey"
        css={css`
          border: none;
        `}
      >
        <Flex
          alignItems="center"
          justifyContent="flex-start"
          color="darkGrey"
          css={theme => css`
            gap: ${theme.space[3]}px;
            &:hover {
              color: ${theme.colors.primary};
              svg {
                stroke: ${theme.colors.primary};
              }
            }
          `}
        >
          <Text
            textAlign="left"
            fontSize={[1, 2]}
            fontWeight={600}
            lineHeight={1.4}
            letterSpacing="initial"
            css={css`
              text-transform: none;
            `}
          >
            {text}
          </Text>

          <Info
            size={iconWidth}
            css={css`
              display: block;
            `}
          />
        </Flex>
      </Button>
    ) : (
      <Text
        fontSize={[1, 2]}
        fontWeight={600}
        lineHeight={1.4}
        letterSpacing="initial"
        color="darkGrey"
        css={css`
          text-transform: none;
        `}
      >
        {text}
      </Text>
    )}
  </Flex>
);

export default InfoLabel;
